export default "__VITE_ASSET__BVAUM$GW__"